module.exports = __webpack_public_path__ + "static/img/yin-icon.e455b9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/yin-icon.png
// module id = zUTq
// module chunks = 1